import { defineComponent as _defineComponent } from 'vue'
import {useTranslations} from "@/hooks/useTranslations";
import Package from "@/models/Subscriptions/SubscriptionPackages/Package";
import {round} from "@/utils/Helpers";
import {computed} from "vue";
import Coupon, {DiscountType} from "@/models/Coupon/Coupon";
import {SubscriptionMigration} from "@/models/Subscriptions/SubscriptionPackages/SubscriptionMigration";
import VPreLoader from "@/components/vPreLoader.vue";

type CostSummaryProps = {
  selectedPackage: Package;
  isUpgrade: boolean;
  isTrialOrExpired: boolean;
  isProratedUpgrade: boolean;
  numberOfPaidLicenses: number;
  subscriptionMigrationInformation: SubscriptionMigration;
  coupon: Coupon | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CostSummary',
  props: {
    selectedPackage: null,
    isUpgrade: { type: Boolean },
    isTrialOrExpired: { type: Boolean },
    isProratedUpgrade: { type: Boolean },
    numberOfPaidLicenses: null,
    subscriptionMigrationInformation: null,
    coupon: null
  },
  setup(__props: any) {

const props = __props as {
  selectedPackage: Package;
  isUpgrade: boolean;
  isTrialOrExpired: boolean;
  isProratedUpgrade: boolean;
  numberOfPaidLicenses: number;
  subscriptionMigrationInformation: SubscriptionMigration;
  coupon: Coupon | null;
};



const translations = useTranslations();

const totalAmount = computed(() => {
  let cost = props.selectedPackage.price;
  // Add the price of the checked addons
  cost += checkedAddOnsPrice();

  // Add the price of the user licenses
  cost += userLicensesCost.value;

  // If the subscription is upgrade calculate the cost with the pro-rate
  if (props.subscriptionMigrationInformation) {
    cost = props.subscriptionMigrationInformation.actualCost;
  }

  // var total = cost - couponDiscount;
  let total = cost + hstAmount() - couponDiscount.value;
  return round(total, 2);
});

const userLicensesCost = computed(() => {
  if (props.numberOfPaidLicenses > 0) {
    let priceRange = props.selectedPackage.userLicensePricingRanges
      .toSorted((a, b) => (a.from - b.from))
      .find(
        (x) =>
          x.from <= props.numberOfPaidLicenses &&
          (x.to == null || x.to >= props.numberOfPaidLicenses)
      );

    return priceRange ? props.numberOfPaidLicenses * priceRange.price : 0;
  }

  return 0;
});

const proratedPricing = computed(() => {
  if (props.subscriptionMigrationInformation && props.isUpgrade) {
    return round(
      props.subscriptionMigrationInformation.originalCost - props.subscriptionMigrationInformation.actualCost,
      2
    );
  }

  return 0;
});

const couponDiscount = computed(() => {
  let discount = 0;
  if (props.coupon && props.selectedPackage) {
    let cost = props.selectedPackage.price;
    // Add the price of the checked addons
    cost += checkedAddOnsPrice();
    // Add the price of the user licenses
    cost += userLicensesCost.value;

    if (props.coupon.discountType == DiscountType.Absolute) {
      discount = props.coupon.value;
    }

    else {
      discount = (cost * props.coupon.value) / 100;
    }
  }

  return discount;
});

function selectedAddOnsPrice() {
  let sum = 0;

  for (let addOn of props.selectedPackage.addOns) {
    if (addOn.checked && addOn.price != null) {
      sum += addOn.price;
    }
  }

  return sum;
}

function hstAmount() {
  let cost = props.selectedPackage.price;

  //Add the price of the checked addons
  cost += selectedAddOnsPrice();

  //Add the price of the user licenses
  cost += userLicensesCost.value;

  //If the subscription is upgrade take the actual cost
  if (props.isUpgrade) {
    cost = props.subscriptionMigrationInformation.actualCost;
  }

  cost -= couponDiscount.value;
  return round(cost * 0.13, 2);
}


function checkedAddOnsPrice() {
  let sum = 0;

  for (let addOn of props.selectedPackage.addOns) {
    if (addOn.checked && addOn.price != null) {
      sum += addOn.price;
    }
  }

  return sum;
}

return { __sfc: true,props, translations, totalAmount, userLicensesCost, proratedPricing, couponDiscount, selectedAddOnsPrice, hstAmount, checkedAddOnsPrice, VPreLoader }
}

})